// extracted by mini-css-extract-plugin
module.exports = {"chevron":"CallToAction_chevron__9lS6A","quick-links":"CallToAction_quick-links__2vtAn"};